import React from 'react'
import { ShareIntro } from './subcomponents/share-intro'
import { ShareSectionBackgroundImages } from './subcomponents/share-section-bg-images'
import { ShareSectionContentSwitch } from './subcomponents/share-section-content-switch'

const ShareCardSection = (props) => {

    return (
        <div>
            <ShareIntro {...props}/>
            <ShareSectionContentSwitch {...props}/>
            <ShareSectionBackgroundImages/>


            <style jsx>{`
                div {
                    background: var(--color--taupe);
                    position: relative;
                    height: 860px;
                }

                @media (pointer: coarse), (max-width: 769px) {
                    div {
                        height: auto;
                        padding-bottom: 240px;
                    }
                }

            `}</style>
        </div>
    )
}



export default ShareCardSection